import axios from "axios";
import AuthenticationFailureHandler from "../utils/AuthenticationFailureHandler";
import { ACCESSORIES_PRICING_URL } from "../utils/EmpUtil";
import { is401 } from "../errors/ErrorConstants";
class CategorySettingsClient {
  static baseUrl = ACCESSORIES_PRICING_URL;

  static getDealerCategorySettings(user, brand) {
    const url = `${
      this.baseUrl
    }/accessories/category-settings?dealerCommonId=${user.getCommonIds()}&brand=${brand}`;

    return axios
      .get(url)
      .then((response) => {
        return response.data.result.categorySettingsGroup;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static saveDealerCategorySettings(
    user,
    data,
    modifiedLaborRate,
    modifiedMarkup
  ) {
    const url = `${
      this.baseUrl
    }/accessories/category-settings/save?dealerCommonId=${user.getCommonIds()}&modifiedLaborRate=${modifiedLaborRate}&modifiedMarkup=${modifiedMarkup}`;

    return axios
      .post(url, data)
      .then(() => {
        return Promise.resolve(true);
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }
}

export default CategorySettingsClient;
